module.exports = __webpack_public_path__ + "static/touchdown-on-the-red-planet-99d14d8748cb5a4518b54801cf112293.jpg";